module.exports = __webpack_public_path__ + "img/75.3625d440.jpg";